<template>
  <div class="row pb-1 mx-1">
    <div class="col-12">
      <div class="row">
        <div class="col-auto p-1">
          <img
            src="@/assets/avatar.jpg"
            style="width: 30px"
            class="rounded-circle"
          />
        </div>
        <div class="col card bg-light border-info rounded">
          <div class="d-flex flex-column">
            <h6 class="card-title my-auto">
              Taha Malaldır<span class="text-muted" id="yorum-text"> - 1s</span>
            </h6>
            <p class="card-text lh-sm" id="yorum-text">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit.
              Reiciendis dolore magni asperiores corporis nobis hic.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 ms-5 mb-1">
      <div class="btn fw-bold p-0 yorum me-2">Beğen</div>
      <span class="text-muted" style="font-size: 12px"
        ><i class="fas fa-thumbs-up"></i> {{ "1" }}</span
      >
      |
      <div class="btn fw-bold p-0 yorum me-2" @click="isComment = true">
        Yanıtla
      </div>
      <span class="text-muted" style="font-size: 12px"
        ><i class="fas fa-comment"></i> {{ "1" }}</span
      >
    </div>
    <paylasim-alt-yorum />
    <input-comment v-if="isComment" />
  </div>
</template>

<script>
import InputComment from "./InputComment.vue";
import PaylasimAltYorum from "./PaylasimAltYorum.vue";
export default {
  components: { PaylasimAltYorum, InputComment },
  data() {
    return {
      isComment: false,
    };
  },
};
</script>

<style>
#yorum-text {
  font-size: 14px;
}
.yorum {
  font-size: 12px;
}
.yorum:hover {
  color: #0dcaf0;
}
</style>
